import * as turf from '@turf/turf'
import { LatLngTuple } from 'leaflet'
import { GridMalha, GridPolygon } from '../components/gerarMalha'
import shpwrite from '@mapbox/shp-write'
import { destroyAlert, errorAlert } from '../../../../../../../../../../../../../../../utils/alert'

export const opcoesArquivos = [
  { id: 1, nome: 'Kml' },
  { id: 2, nome: 'Shp' },
]

export const encontrarIndexDoPoligono = (point, malhaPolygonsMover) => {
  for (let i = 0; i < malhaPolygonsMover.length; i++) {
    const polygon = malhaPolygonsMover[i].polygon
    if (turf.booleanPointInPolygon(point, polygon)) {
      return i
    }
  }
  return -1 // não achou nenhum
}

/** Transforma uma bbox retangular em *quadrada* (expande o lado menor) */
export function squareBBox(
  [minX, minY, maxX, maxY]: number[],
  scale = 1.4 // aumenta 20% por padrão
): turf.BBox {
  const width = maxX - minX
  const height = maxY - minY
  let newMinX = minX
  let newMinY = minY
  let newMaxX = maxX
  let newMaxY = maxY

  if (width > height) {
    const delta = (width - height) / 2
    newMinY -= delta
    newMaxY += delta
  } else {
    const delta = (height - width) / 2
    newMinX -= delta
    newMaxX += delta
  }

  // Aplica a expansão geral
  const centerX = (newMinX + newMaxX) / 2
  const centerY = (newMinY + newMaxY) / 2
  const halfWidth = ((newMaxX - newMinX) / 2) * scale
  const halfHeight = ((newMaxY - newMinY) / 2) * scale

  return [centerX - halfWidth, centerY - halfHeight, centerX + halfWidth, centerY + halfHeight]
}

//ROTAÇÃO DO GRID
export function rotatePoint(
  point: LatLngTuple,
  center: LatLngTuple,
  angleDeg: number
): LatLngTuple {
  const angleRad = (angleDeg * Math.PI) / 180
  const [cx, cy] = [center[1], center[0]] // lng, lat
  const [px, py] = [point[1], point[0]]

  const dx = px - cx
  const dy = py - cy

  const rotatedX = dx * Math.cos(angleRad) - dy * Math.sin(angleRad)
  const rotatedY = dx * Math.sin(angleRad) + dy * Math.cos(angleRad)

  const newLng = cx + rotatedX
  const newLat = cy + rotatedY

  return [newLat, newLng]
}

//GERA O GRID PADRÃO
export function gerarGrid(
  gridLevel: number,
  polygon,
  areaHectares,
  setGrid,
  setGridOriginal,
  setGridOriginalRotacao,
  setTamanhoGridOriginal,
  setLoading: Function,
  setQuadrante
) {
  if (gridLevel !== 0) {
    const bbox = squareBBox(turf.bbox(polygon))
    const numCells = areaHectares / gridLevel
    const totalAreaM2 = areaHectares * 10000
    const areaPerCellM2 = totalAreaM2 / numCells
    const cellSideKm = Math.sqrt(areaPerCellM2) / 1000
    const gridPolys = turf.squareGrid(bbox, cellSideKm, { units: 'kilometers' })

    // const malhaPolygons: GridPolygon[] = gridPolys.features.map((cell, index) => {
    // const movedCoords = cell.geometry.coordinates[0].map(([lng, lat]) => [lng, lat])

    // const polygon = turf.polygon([movedCoords])

    //   return {
    //     id: index + 2,
    //     polygon,
    //   }
    // })
    setQuadrante(areaPerCellM2)

    let cells: GridMalha[] = gridPolys.features.map((cell, index) => {
      const centerCoords = turf.centerOfMass(cell).geometry.coordinates
      const movedCoords = cell.geometry.coordinates[0].map(([lng, lat]) => [lng, lat])

      const polygon = turf.polygon([movedCoords])
      const [lng, lat] = centerCoords

      return {
        id: index + 1,
        center: [lat, lng],
        idPolygon: index + 2,
        oculto: false,

        polygons: polygon,
      }
    })

    const pontosDentroDoTalhao = cells.map((item) => {
      const ponto = turf.point([item.center[1], item.center[0]])
      const dentro = turf.booleanPointInPolygon(ponto, polygon)

      return {
        ...item,

        oculto: dentro ? false : true,
      }
    })
    const tamanhoGrid = pontosDentroDoTalhao.filter(({ center }) =>
      turf.booleanPointInPolygon(turf.point([center[1], center[0]]), polygon)
    )

    // setMalhaPolygon(malhaPolygons)
    // setMalhaPolygonOriginal(malhaPolygons)
    setGrid(pontosDentroDoTalhao)
    setGridOriginal(pontosDentroDoTalhao)
    setGridOriginalRotacao(pontosDentroDoTalhao)
    setTamanhoGridOriginal(tamanhoGrid?.length)
    destroyAlert('loading')
    setLoading('')
  } else {
    errorAlert('Informe um valor diferente de 0!')
    // setClicou(false)
    destroyAlert('loading')
    setLoading('')
  }
}

export function calcularCentroTurf(coords) {
  const convertKml = criarPoligono(coords)
  const centro = turf.centroid(convertKml)
  return centro.geometry.coordinates // retorna [lng, lat]
}

const handleDownload = (geoJsonData, nome) => {
  if (!geoJsonData) {
    alert('Nenhum dado GeoJSON para converter.')
    return
  }

  shpwrite
    .zip(geoJsonData, {
      outputType: 'blob',
      compression: 'DEFLATE',
    })
    .then((result) => {
      const zipBlob = result as Blob

      const fileName = `Malha Geral-${nome}.zip`

      const url = URL.createObjectURL(zipBlob)

      const a = document.createElement('a')
      a.href = url
      a.download = fileName
      document.body.appendChild(a)
      a.click()

      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    })
    .catch((error) => {
      console.error('Erro ao converter para Shapefile:', error)
      alert('Ocorreu um erro durante a conversão.')
    })
}

export function gerarArquivoShp(pontos: GridMalha[], nomeTalhao: string) {
  const geojson = {
    type: 'FeatureCollection',
    features: pontos.map((item, index) => ({
      type: 'Feature',
      properties: {
        INDICE: item.id,
        NOME: item.posicao,
        COMENTARIO: '',
        ICONE: '',
        ALTITUDE: '',
        DATA: '',
        ANGULO: '',
        DISPLAY: '',
        ZONA: '',
        LATITUDE: item.center[1],
        LONGITUDE: item.center[0],
      },
      geometry: {
        type: 'Point',
        coordinates: [item.center[1], item.center[0]],
      },
    })),
  }
  handleDownload(geojson, nomeTalhao)
}

export function criarPoligono(coordenadasKml): turf.Feature<turf.Polygon> | null {
  if (!Array.isArray(coordenadasKml)) return null

  // Inverte para [lng, lat]
  const convertKml = coordenadasKml.map(([lat, lng]) => [lng, lat])

  // Fecha o anel se não estiver fechado
  if (
    convertKml.length >= 3 &&
    JSON.stringify(convertKml[0]) !== JSON.stringify(convertKml[convertKml.length - 1])
  ) {
    convertKml.push(convertKml[0])
  }

  // Valida tamanho mínimo
  if (convertKml.length < 4) {
    console.log('Polígono ignorado: menos de 4 pontos após fechamento.')
    return null
  }

  // Cria o polígono válido
  return turf.polygon([convertKml])
}

// export function criarPoligonosValidos(coordenadasKml): Feature<Polygon>[] {
//   if (!Array.isArray(coordenadasKml)) return []

//   // Converte tudo para [lng, lat]
//   let convertKml: [number, number][] = coordenadasKml
//     .map((coord) => {
//       if (Array.isArray(coord) && coord.length === 2) {
//         const [lat, lng] = coord
//         return [lng, lat]
//       } else if ('lat' in coord && 'lng' in coord) {
//         return [coord.lng, coord.lat]
//       } else {
//         return null
//       }
//     })
//     .filter((c): c is [number, number] => Array.isArray(c) && c.length === 2)

//   // 2. Remove pontos duplicados globais (exceto o último que será re-adicionado)
//   const vistos = new Set<string>()
//   convertKml = convertKml.filter(([lng, lat]) => {
//     const chave = `${lng},${lat}`
//     if (vistos.has(chave)) return false
//     vistos.add(chave)
//     return true
//   })

//   // 3. Fecha o anel
//   if (
//     convertKml.length >= 3 &&
//     (convertKml[0][0] !== convertKml[convertKml.length - 1][0] ||
//       convertKml[0][1] !== convertKml[convertKml.length - 1][1])
//   ) {
//     convertKml.push(convertKml[0])
//   }

//   if (convertKml.length < 4) {
//     console.warn('Polígono ignorado: menos de 4 pontos após fechamento.')
//     return []
//   }

//   const poligono = turf.polygon([convertKml])

//   // Verifica cruzamentos (kinks)
//   const kinks = turf.kinks(poligono)
//   if (kinks.features.length > 0) {
//     console.warn('Polígono com cruzamentos detectado. Aplicando unkinkPolygon().')
//     const desenrolado = turf.unkinkPolygon(poligono)
//     return desenrolado.features as Feature<Polygon>[]
//   }

//   // Polígono válido
//   return [poligono]
// }

// export function separarPoligonos(coordenadas: number[][][]): Feature<Polygon>[] {
//   return coordenadas
//     .filter((coords) => coords.length >= 4) // Ignora contornos inválidos
//     .map((coords) => {
//       console.log(coords)
//       const primeiro = coords[0]
//       const ultimo = coords[coords.length - 1]

//       // Fecha o contorno se necessário
//       if (primeiro[0] !== ultimo[0] || primeiro[1] !== ultimo[1]) {
//         coords.push([...primeiro])
//       }

//       return turf.polygon([coords])
//     })
// }

function gerarGridKml(grid: GridMalha[], nomeTalhao: string) {
  const nome = nomeTalhao === undefined ? '' : nomeTalhao
  const header = `<?xml version="1.0" encoding="UTF-8"?>
  <kml xmlns="http://www.opengis.net/kml/2.2">
    <Document>
      <name>${nome}</name>`

  const placemarks = grid
    ?.map((ponto) => {
      const [lat, lng] = ponto?.center
      return `
      <Placemark>
        <name>${ponto.posicao}</name>
        <Point>
          <coordinates>${lng},${lat},0</coordinates>
        </Point>
      </Placemark>`
    })
    .join('')

  const footer = `
    </Document>
  </kml>`

  return header + placemarks + footer
}

export function baixarGridKML(pontos: GridMalha[], nomeTalhao) {
  const nome = nomeTalhao === undefined ? '' : nomeTalhao
  const conteudo = gerarGridKml(pontos, nomeTalhao)
  const blob = new Blob([conteudo], { type: 'application/vnd.google-earth.kml+xml' })
  const url = URL.createObjectURL(blob)

  const a = document.createElement('a')
  a.href = url
  a.download = `Malha Geral-${nome}.kml`
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
